const es = {
  global: {
    waiter: 'Camarero',
    gastrohome: 'Gastrohome',
    admin: 'Entorno de administración Gastrohome',
    owner: 'Administrador de [x] • Desarrollado por Gastrohome',
    staff: 'Personal de [x] • Desarrollado por Gastrohome',
    welcome: 'Bienvenido a [x] • Desarrollado por Gastrohome',
    goodBye: 'Nos vemos en [x] • Desarrollado por Gastrohome',
    e404: 'Página no encontrada • Gastrohome',
    saved: 'Salvado',
  },
  e404: {
    title: 'Aquí va mal algo...',
    copy: 'No podemos encontrar la página. Puede que (ya) no exista.',
    btn: 'Volver a Gastrohome',
  },
  browserCheck: {
    title: 'Lamentablemente, su navegador no es compatible',
    copy:
      'Para aprovechar al máximo Gastrohome, recomendamos utilizar Google Chrome como navegador.',
    btn: 'Descargar Chrome',
  },
  home: {
    select: 'Seleccione el restaurante donde hizo su pedido:',
  },
  accesCode: {
    copy: 'Introduzca su código de acceso',
    btn: 'Venga adentro',
  },
  permissions: {
    questionHeader: 'Estamos llegando ...',
    questionCopy:
      'Para usar Gastrohome, necesitamos acceso a la cámara web y al micrófono de su ordenador ...',
    deniedCopy: 'Parece que este navegador no puede acceder a la cámara web',
    deniedBtn: 'Regresar a la entrada',
  },
  checkIn: {
    welcome: 'Bienvenido a',
    busy: 'El vestíbulo está muy lleno. <br/> Por favor inténtelo de nuevo en unos minutos.',
    retry: 'Inténtelo de nuevo',
    save: 'Guardar',
    placeholder: '¿Cómo podemos llamarle(s)?',
  },
  fullScreen: {
    enter: 'Ver página a pantalla completa',
    leave: 'Salga del modo de pantalla completa',
  },
  seating: {
    welcome: 'Bienvenidos [x] <br /> su camarero estará pronto con usted.',
  },
  agora: {
    micOff: 'El micrófono está apagado',
    talkingToWaiter: 'En conversación con el camarero',
    watchingAVideo: 'Mira un video',
  },
  callWaiter: {
    call: 'Camarero',
    called: 'Camarero llamado',
    message: 'El camarero sigue ocupado, un momento por favor',
  },
  finished: {
    back: 'De vuelta al lobby',
    title: '¡Le agradecemos mucho que nos permita entrar en su casa!',
    copy: 'Esperamos volver a verle pronto.',
    tipCopy: '¿Desea dejarle una propina al camarero? Entonces puede con este botón.',
    tipBtn: 'Dejar propina',
  },
  offline: {
    title: 'La página no está en línea',
    copy: 'Comprueba tu conexión a Internet y actualizar la página después.',
  },
  auth: {
    loggedInAs: 'Conectado como',
    logout: 'Cerrar sesión',
  },
  staff: {
    lobby: 'Vestíbulo',
    sidebar: {
      guest: 'Invitado',
      guests: 'Invitados',
      noneSeatingId: 'Sin identificación del asiento',
      restaurantSettings: 'Configuraciones',
    },
    guestBox: {
      startUp: 'Introducir nombre y encender la cámara.',
      calledWaiter: 'Me gustaría una llamada en personal',
      attend: 'Ir a llamada personal',
      isAttended: 'Ayuda de camino',
      stopAttend: 'Terminar llamada personal',
      privateOption: '- Vestíbulo -',
      canSeeItself: 'Puede verse a sí mismo',
      stateWelcome: 'Para dar la bienvenida',
      stateService: 'En conversación',
      stateReturning: 'Invitado que regresa',
      stateWatchingVideo: 'está viendo un vídeo',
      confirmFinish: '?Esta seguro de desea eliminar este invitado?',
      confirmRefresh: '?Esta seguro?',
    },
    messageBox: {
      placeholder: 'Ingrese un mensaje corto',
    },
    saveName: {
      placeholder: 'Nombre del camarero',
    },
    rooms: {
      title: 'Administrar habitaciones',
      up: 'Arriba',
      down: 'Abajo',
      edit: 'Editar',
      delete: 'eliminar',
      room: 'Habitación',
      roomEdit: 'editar',
      roomCreate: 'crear',
      name: 'Nombre de la habitación',
      size: 'Numero maximo de personas',
      volumneGuests: 'Volumen - invitados',
      volumeArtist: 'Volumen - artista',
      private: 'Habitación privada',
      isEndRoom: 'Es el cuarto final',
      save: 'Guardar',
      confirm: '¿Seguro que quieres eliminar esta sala? Los invitados irá al vestíbulo.',
    },
    videos: {
      title: 'Administrar videos de YouTube',
      placeholder: 'ID de video de Youtube',
      descriptionPlaceholder: 'Descripción del video de Youtube',
      mute: 'Silencia mi sonido',
      unmute: 'Enciende mi sonido',
      add: 'añadir',
      save: 'Guardar',
      confirm: '¿Estás seguro de que deseas eliminar este video?',
      noVideo: 'Ningún video seleccionado',
    },
    participate: {
      start: 'Participar',
      stop: 'Dejar de participar',
    },
    artistVideo: {
      title: 'Reproducir video de YouTube',
      stop: 'Detener el video',
      fullscreen: 'Fullscreen',
      artist: 'Artista',
    },
  },
  owner: {
    manage: 'administrar',
    settings: 'Configuraciones',
    codes: 'Códigos de acceso',
    waiters: 'Camareros',
    waiterPageLink: 'A la página del camarero',
    adminPageLink: 'Administrador',
    profile: {
      title: 'Configuraciones',
      name: 'Nombre del restaurante',
      wallpaper: 'Imagen de fondo',
      logoSmall: 'Logo pequeño: ubicado en la parte inferior derecha de la pantalla con invitados',
      logoBig: 'Logotipo grande: ubicado en la página de inicio de sesión y en la pantalla final',
      pickImage: 'Elige imagen',
      thankyouTitle: 'Título de la página de agradecimiento',
      thankyouCopy: 'Texto de la página de agradecimiento',
      thankyouTipCopy: 'Texto de sugerencia página de agradecimiento',
      seatingWelcomeCopy: 'Texto de bienvenida',
      seatingWelcomeInfo:
        'Nota: Utilice [x] donde debería estar el nombre del invitado. Utilice <br /> para saltos de línea.',
      emptyField: 'Si este texto no se completa, se mostrará el texto predeterminado:',
      save: 'Guardar',
    },
    publish: {
      title: '(Dejar de) publicar restaurantes',
      btnPublish: 'Publicar',
      btnUnpublish: 'Dejar de publicar',
    },
    accessCodes: {
      title: 'Códigos de acceso',
      copy:
        'Cada código de acceso es válido desde las 06:00 de la mañana a las 05:59 del día siguiente.',
      headingCodes: 'Código',
      headingValid: 'Valido hasta',
      delete: 'eliminar',
      confirm: '¿Desea eliminar permanentemente este asiento? ¡Esto no se puede deshacer!',
      newTitle: 'Crear nuevo código de acceso',
      create: 'Crear',
    },
    staffList: {
      title: 'Camareros',
      forgotPassword: 'Enviar contraseña olvidada del correo',
      delete: 'eliminar',
      confirm: '¿Estás seguro de que quieres privar a este camarero de sus permisos?',
      receivedMail: 'ha recibido un correo electrónico',
    },
    newStaff: {
      title: 'Añadir nuevo camarero',
      email: 'Dirección de correo electrónico',
      save: 'Guardar',
      alertEmail: 'Debes introducir una dirección de correo electrónico',
      alertError: 'Error al crear nuevo camarero',
    },
  },
  admin: {
    title: 'Administrador de Gastrohome',
    menu: {
      admin: 'Restaurantes',
      adminUsers: 'Usuarios',
    },
    restaurants: {
      allTitle: 'Todos los restaurantes',
      waiterPage: 'A la página de los camareros',
      restaurantPage: 'A la página de administración del restaurante',
      delete: 'eliminar',
      confirm: '¿Quieres eliminar permanentemente este restaurante? ¡Esto no se puede deshacer!',
      newTitle: 'Crea un nuevo restaurante',
      newName: 'Nombre del restaurante',
      newEmail: 'Propietario de la dirección de correo electrónico',
      save: 'Guardar',
      alertName: 'Tienes que introducir el nombre de un restaurante',
      alertDuplicate:
        'El restaurante {nombre} con id {id} ya existe (o algo salió mal al crearlo).',
      alertOwner: 'Algo salió mal al crear el propietario.',
    },
    users: {
      title: 'Todos los usuarios',
      admins: 'Administradores',
      owners: 'Propietarios',
      waiters: 'Camareros',
      forgotPassword: 'Enviar contraseña olvidada del correo',
      deleteAdmin: 'Eliminar de los administradores',
      deleteOwner: 'Eliminar de los propietarios de este restaurante',
      deleteStaff: 'Eliminar del personal de este restaurante',
      userNotFound: 'Usuario no encontrado',
      confirmDeleteAdmin:
        '¿Estás seguro de que quieres eliminar los permisos de este administrador?',
      confirmDeleteOwner: '¿Estás seguro de que quieres eliminar los permisos de este propietario?',
      confirmDeleteStaff: '¿Estás seguro de que quieres eliminar los permisos de este camarero?',
      receivedMail: 'ha recibido un correo electrónico',
    },
  },
}
export default es
